"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _propTypes = require("prop-types");

var _FormikValidation = _interopRequireDefault(require("../FormikValidation"));

var _Input = _interopRequireDefault(require("../../Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FormikInput = function FormikInput(props) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_formik.Field, {
    name: props.name
  }, function (_ref) {
    var field = _ref.field;
    return _react.default.createElement(_Input.default, _extends({}, field, props));
  }), _react.default.createElement(_FormikValidation.default, {
    name: props.name
  }));
};

FormikInput.propTypes = {
  name: _propTypes.string.isRequired
};
var _default = FormikInput;
exports.default = _default;